import React, { useState, useEffect } from "react";
import {
  Route,
  Routes,
  Link,
  useLocation,
  useParams,
  useNavigate,
} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import commaNumber from "comma-number";
import { formatTitle } from "../../formatTitle";
import { formatDate } from "../../formatDate";
import { useAppContext } from "../../../AppContext";
import { exportPdf } from "../../../components/exportPdf";
import "./style.scss";

function View1(props) {
  const { user, components, chimeraserv } = useAppContext();
  const location = useLocation();
  const navigate = useNavigate();
  const discounts = location.state?.data;
  const params = useParams();
  const [views] = useState([
    "sales",
    "void",
    "deletion",
    "session",
    "audit",
    "discount",
  ]);
  const [data, setData] = useState([]);
  const [discount, setDiscount] = useState([]);

  const [currency, setCurrency] = useState({
    base: {},
    state: false,
  });
  const [load, setLoad] = useState(false);

  const headers = new Headers({
    Authorization: user.data.usrKey,
    "Content-Type": "application/json",
    Accept: "application/json",
  });

  function renderField(objData) {
    let dataValue = "";

    // For discount items, return null as we'll handle this separately
    if (
      params.type === "discount" &&
      objData[0] === "items" &&
      Array.isArray(objData[1])
    ) {
      return null; // Don't render items here for discount type
    }

    // All other fields: value in black color
    switch (typeof objData[1]) {
      case "string":
        dataValue = (
          <span style={{ color: "black", paddingLeft: "10px" }}>
            {formatTitle(objData[1])}
          </span>
        );
        break;
      case "object":
        if (
          !["items", "payType", "emp", "empSig", "type"].includes(objData[0])
        ) {
          break;
        }
        dataValue = objData[1].map((obj, idx) => (
          <div key={idx}>
            {Object.entries(obj).map((object, i) => {
              let value = "";
              switch (typeof object[1]) {
                case "string":
                  value = ` - ${formatTitle(object[1])}`;
                  break;
                case "number":
                  switch (object[0]) {
                    case "total":
                    case "sales":
                    case "amount":
                      value = ` - ${currency?.base} ${commaNumber(
                        object[1].toFixed(2)
                      )}`;
                      break;
                    case "date":
                      value = ` - ${formatDate.long(object[1])}`;
                      break;
                    default:
                      value = ` - ${commaNumber(object[1])}`;
                      break;
                  }
                  break;
                default:
                  break;
              }
              return (
                <span key={i} style={{ color: "black", paddingLeft: "10px" }}>
                  {value}
                </span>
              );
            })}
          </div>
        ));
        break;
      case "number":
        switch (objData[0]) {
          case "total":
          case "sales":
            dataValue = (
              <span style={{ color: "black", paddingLeft: "10px" }}>
                {currency?.base} {commaNumber(objData[1].toFixed(2))}
              </span>
            );
            break;
          case "date":
            dataValue = (
              <span style={{ color: "black", paddingLeft: "10px" }}>
                {formatDate.long(objData[1])}
              </span>
            );
            break;
          case "billNo":
            dataValue = (
              <span style={{ color: "black", paddingLeft: "10px" }}>
                {" "}
                {objData[1]}
              </span>
            );
            break;
          case "sesNo":
            dataValue = (
              <span style={{ color: "black", paddingLeft: "10px" }}>
                {objData[1]}
              </span>
            );
            break;
          case "delId":
            dataValue = (
              <span style={{ color: "black", paddingLeft: "10px" }}>
                {objData[1]}
              </span>
            );
            break;
          // case "discountNumber":
          //   {
          //     const discName = discount[0]?.discounts.find(
          //       (d) => d.discNumber === objData[1]
          //     )?.discName;
          //     if (params.type !== "discount") {
          //       return (dataValue = (
          //         <span style={{ color: "#fe891cff", paddingLeft: "10px" }}>
          //           {objData[1] !== 0 ? objData[1] : "N/A"}
          //         </span>
          //       ));
          //     } else {
          //       return (dataValue = (
          //         <span style={{ color: "#fe891cff", paddingLeft: "10px" }}>
          //           {discName || "N/A"} ({objData[1] !== 0 ? objData[1] : "N/A"}
          //           )
          //         </span>
          //       ));
          //     }
          //   }
          // break;
          case "discountNumber":
            {
              let discName = "";

              // Check if discountType is COUPON
              console.log("Discount data for debugging:", objData[1]);
              if (data[0].discountType === "COUPON") {
                // For COUPON type, find discount with matching discNumber and type = 1
                discName = discount[0]?.discounts.find(
                  (d) => d.discNumber === objData[1] && d.type === 1
                )?.discName;
              } else {
                // For other discount types, find by discNumber only
                discName = discount[0]?.discounts.find(
                  (d) => d.discNumber === objData[1]
                )?.discName;
              }

              if (params.type !== "discount") {
                return (dataValue = (
                  <span style={{ color: "#fe891cff", paddingLeft: "10px" }}>
                    {objData[1] !== 0 ? objData[1] : "N/A"}
                  </span>
                ));
              } else {
                return (dataValue = (
                  <span style={{ color: "#fe891cff", paddingLeft: "10px" }}>
                    {discName || "N/A"} ({objData[1] !== 0 ? objData[1] : "N/A"}
                    )
                  </span>
                ));
              }
            }
            break;
          default:
            dataValue = (
              <span style={{ color: "black", paddingLeft: "10px" }}>
                {commaNumber(objData[1])}
              </span>
            );
            break;
        }
        break;
      default:
        break;
    }

    return dataValue;
  }

  // PDF Export function
  const exportToPDF = () => {
    if (!data[0]) return;

    const orderData = data[0];
    const items = orderData.items || [];

    // Calculate totals for discount type
    let totalRaw = 0;
    let totalDiscount = 0;
    let finalAmount = 0;

    if (params.type === "discount" && items.length > 0) {
      totalRaw = items.reduce(
        (total, item) => total + (item.amount * item.qty || 0),
        0
      );
      totalDiscount = totalRaw - (data[0]?.total || 0);
      // items.reduce(
      //   (total, item) => total + (item?.discount?.discountAmt || 0),
      //   0
      // );
      finalAmount = totalRaw - totalDiscount;
    }

    // Prepare table data for exportPdf
    const tableData = [];

    // Header for the items table
    const tableHead =
      params.type === "discount"
        ? [
            [
              "Item",
              "Qty",
              "Raw Price",
              "Discount Amount",
              "Final Price",
              "Item Discount Name",
            ],
          ]
        : [["Item", "Qty", "Price"]];

    // Body data for the items table
    const tableBody = items.map((item) => {
      const discountNumber = item?.discount?.discountNo;
      const discName = discount[0]?.discounts.find(
        (d) => d.discNumber === discountNumber
      )?.discName;
      const rawPrice = item.amount || 0;
      const discountAmount = item?.discount?.discountAmt || 0;
      const finalPrice = rawPrice - discountAmount;
      if (params.type === "discount") {
        return [
          formatTitle(item.name),
          (item.qty || 1).toString(),
          `${currency?.base} ${commaNumber(rawPrice.toFixed(2))}`,
          `${currency?.base} ${commaNumber(discountAmount.toFixed(2))}`,
          `${currency?.base} ${commaNumber(finalPrice.toFixed(2))}`,
          discountNumber && discountNumber !== 0
            ? discName || `Discount #${discountNumber}`
            : "No Discount",
        ];
      } else {
        return [
          formatTitle(item.name),
          (item.qty || 1).toString(),
          `${currency?.base} ${commaNumber(rawPrice.toFixed(2))}`,
        ];
      }
    });

    // Add summary rows for discount type
    if (params.type === "discount") {
      tableBody.push(
        ["", "", "", "", "", ""], // Empty row for spacing
        ["SUMMARY", "", "", "", "", ""],
        [
          "Total Before Discount",
          "",
          `${currency?.base} ${commaNumber(totalRaw.toFixed(2))}`,
          "",
          "",
          "",
        ],
        [
          "Total Discount",
          "",
          "",
          `${currency?.base} ${commaNumber(totalDiscount.toFixed(2))}`,
          "",
          "",
        ],
        [
          "Total After Discount",
          "",
          "",
          "",
          `${currency?.base} ${commaNumber(finalAmount.toFixed(2))}`,
          "",
        ]
      );
    }

    tableData.push({
      head: tableHead,
      body: tableBody,
    });

    // Prepare order details for the header section

    const orderDetails = Object.entries(orderData)
      .filter(
        ([key]) =>
          ![
            "_id",
            "status",
            "braKey",
            "chaKey",
            "grpKey",
            "__v",
            "items",
          ].includes(key)
      )
      .map(([key, value]) => {
        const label = fieldLabels[key] || formatTitle(key);
        let displayValue = "";

        if (typeof value === "string") {
          displayValue = formatTitle(value);
        } else if (typeof value === "number") {
          if (key === "total" || key === "sales") {
            displayValue = `${currency?.base} ${commaNumber(value.toFixed(2))}`;
          } else if (key === "date") {
            displayValue = formatDate.long(value);
          } else if (key === "discountNumber") {
            const discName = discount[0]?.discounts.find(
              (d) => d.discNumber === value
            )?.discName;
            displayValue = `${discName || "N/A"} (${
              value !== 0 ? value : "N/A"
            })`;
          } else {
            displayValue = commaNumber(value.toFixed(2));
          }
        } else if (Array.isArray(value)) {
          if (key === "payType") {
            displayValue = value
              .map((p) =>
                typeof p === "object"
                  ? formatTitle(p.type || "")
                  : formatTitle(p)
              )
              .join(", ");
          } else if (key === "emp") {
            displayValue = value
              .map((e) =>
                typeof e === "object"
                  ? formatTitle(e.name || "")
                  : formatTitle(e)
              )
              .join(", ");
          } else if (key === "discountsApplied") {
            displayValue = value
              .map((d) => d.discountName)
              .filter(Boolean)
              .join(", ");
          } else {
            displayValue = "Multiple entries";
          }
        }

        return `${label}: ${displayValue}`;
      })
      .join("\n");

    // Create the export data structure

    const filter = location.state.filter || {};
    const exportData = {
      title: `${formatTitle(params.type)} Details (${formatTitle(
        location.state.data.businessName
      )}) - ${orderData.billNo || "Order"}`,
      businessName: location.state.data.businessName,
      // filter: {
      //   brands: filter.data.brands.map((brand) => brand.name),
      //   chains: filter.data.chains.map((chain) => chain.name),
      //   revCent: filter.data.revCent.map((revCent) => revCent.name),
      //   payType: filter.data.payType.map((payType) => payType.name),
      //   date: {
      //     start: filter.data.date.start,
      //     end: filter.data.date.end,
      //   },
      // },
      body: tableData,
      orderDetails: orderDetails, // Add order details to be included in the PDF
    };

    // Use the existing exportPdf.table function
    exportPdf.table(exportData);
  };

  function renderItemsTable() {
    if (params.type !== "discount" || !data[0]?.items) return null;

    const items = data[0].items;

    return (
      <div className="items-table-container">
        <h3>Items</h3>
        <table className="table table-striped items-table">
          <thead>
            <tr>
              <th>Item</th>
              <th>Qty</th>
              <th>Original price</th>
              <th>Price paid</th>
              <th>line Discount Name</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, idx) => {
              const discountNumber = item?.discount?.discountNo;
              // Apply the same COUPON logic
              let discName = "";
              if (data[0]?.discountType === "COUPON") {
                // For COUPON type, find discount with matching discNumber and type = 1
                const foundDiscount = discount[0]?.discounts?.find(
                  (d) => d.discNumber === discountNumber && d.type === 1
                );
                discName = foundDiscount?.discName || "N/A";
              } else {
                // For other discount types, find by discNumber only
                const foundDiscount = discount[0]?.discounts?.find(
                  (d) => d.discNumber === discountNumber
                );
                discName = foundDiscount?.discName || "N/A";
              }
              const rawPrice = item.amount * (item.qty || 1) || 0;
              const discountAmount = item?.discount?.discountAmt || 0;
              const discountedPrice = rawPrice - discountAmount;

              return (
                <tr key={idx}>
                  <td className="item-name">{formatTitle(item.name)}</td>
                  <td className="item-qty">{item.qty || 1}</td>
                  <td className="raw-price">
                    {currency?.base} {commaNumber(rawPrice.toFixed(2))}
                  </td>
                  <td className="discount-price">
                    {discountAmount > 0 ? (
                      <span style={{ color: "#da7a20ff", fontWeight: "bold" }}>
                        {currency?.base}{" "}
                        {commaNumber(discountedPrice.toFixed(2))}
                      </span>
                    ) : (
                      <span style={{ color: "#111111d6" }}>
                        {currency?.base} {commaNumber(rawPrice.toFixed(2))}
                      </span>
                    )}
                  </td>
                  <td className="discount-name">
                    {discountNumber && discountNumber !== 0 ? (
                      <span style={{ color: "#da7a20ff", fontWeight: "bold" }}>
                        {discName || `Discount #${discountNumber}`}
                      </span>
                    ) : (
                      <span style={{ color: "#888" }}>No Discount</span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* Summary section */}
        <div className="items-summary">
          <div className="summary-row">
            <strong>Total Before Discount: </strong>
            <span style={{ color: "black" }}>
              {currency?.base}{" "}
              {commaNumber(
                items
                  .reduce(
                    (total, item) =>
                      total + (item.amount * (item.qty || 1) || 0),
                    0
                  )
                  .toFixed(2)
              )}
            </span>
          </div>
          <div className="summary-row">
            <strong>Total Discount: </strong>
            <span style={{ color: "#da7a20ff" }}>
              {currency?.base}{" "}
              {commaNumber(
                (
                  items.reduce(
                    (total, item) =>
                      total + (item.amount * (item.qty || 1) || 0),
                    0
                  ) - (data[0]?.total || 0)
                ).toFixed(2)
              )}
            </span>
          </div>
          <div className="summary-row">
            <strong>Total After Discount: </strong>
            <span style={{ color: "#222222ff", fontWeight: "bold" }}>
              {currency?.base} {commaNumber((data[0]?.total || 0).toFixed(2))}
            </span>
          </div>
        </div>
      </div>
    );
  }

  const fieldLabels =
    params.type === "discount"
      ? {
          payType: "Payment Type",
          emp: "Employee",
          billNo: "Order Number",
          sesNo: "Session Number",
          table: "Table",
          total: "Total",
          customers: "Customers",
          revCent: "Revenue Center",
          date: "Date",
          discountNumber: "Check Discount Name",
          discount: "Item Discount",
          items: "Items",
        }
      : {
          payType: "Payment Type",
          emp: "Employee",
          billNo: "Order Number",
          sesNo: "Session Number",
          table: "Table",
          total: "Total",
          customers: "Customers",
          revCent: "Revenue Center",
          date: "Date",
          discountNumber: "Check Discount Number",
          // discount: "Item Discount",
          items: "Items",
        };

  const handleBackClick = () => {
    if (location.state?.prevUrl) {
      // Navigate back to the specific URL with state indication
      navigate(location.state.prevUrl, {
        state: {
          prevUrl: location.pathname,
          preserveData: true,
          returnedFromView: true,
          timestamp: Date.now(),
        },
        replace: false, // Don't replace history entry
      });
    } else {
      // Fallback to browser back
      navigate(-1);
    }
  };

  function renderData() {
    const Loader = components.setting[1].component;

    const obj = data.length
      ? Object.entries(data[0]).filter(
          (d) =>
            !["_id", "status", "braKey", "chaKey", "grpKey", "__v"].includes(
              d[0]
            )
        )
      : [];

    return (
      <div className={["custForm", "custView"].join(" ")}>
        <div className={["viewTitle"]}>
          <button
            onClick={handleBackClick}
            className="back-button"
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: 0,
              color: "inherit",
              fontSize: "inherit",
            }}
          >
            <FontAwesomeIcon
              className={["iconBack"].join(" ")}
              icon={["fas", "caret-left"]}
            />
          </button>
          View {formatTitle(params.type)}
          {params.type === "discount" ? (
            <button
              onClick={exportToPDF}
              className="export-button"
              style={{
                background: "#da7a20ff",
                color: "white",
                border: "none",
                padding: "8px 12px",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "500",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                marginLeft: "auto",
              }}
            >
              <FontAwesomeIcon icon={["fas", "download"]} />
              Export to PDF
            </button>
          ) : null}
        </div>

        {!load ? (
          <Loader />
        ) : (
          <div
            className={params.type === "discount" ? "discount-layout" : "form"}
          >
            {params.type === "discount" ? (
              <>
                {/* Left side - Details */}
                <div className="discount-details">
                  {/* Show discounts applied to the order */}
                  {data[0]?.discountsApplied &&
                    Array.isArray(data[0].discountsApplied) &&
                    data[0].discountsApplied.length > 0 && (
                      <div className="field-row">
                        <span className="field-label">Discounts Applied:</span>
                        <span className="field-value">
                          {data[0].discountsApplied
                            .map((d) => d.discountName)
                            .filter(Boolean)
                            .join(", ")}
                        </span>
                      </div>
                    )}

                  {/* Other details (excluding items) */}
                  {obj
                    .filter((objData) => objData[0] !== "items")
                    .map((objData, dataKey) => {
                      const fieldValue = renderField(objData);
                      if (fieldValue === null) return null;

                      return (
                        <div className="field-row" key={dataKey}>
                          <span className="field-label">
                            {fieldLabels[objData[0]] || formatTitle(objData[0])}
                            :
                          </span>
                          <span className="field-value">{fieldValue}</span>
                        </div>
                      );
                    })}
                </div>

                {/* Right side - Items Table */}
                <div className="discount-items">{renderItemsTable()}</div>
              </>
            ) : (
              <>
                {obj.map((objData, dataKey) => (
                  <div className={["form-group"]} key={dataKey}>
                    <label htmlFor="exampleInputEmail1">
                      {fieldLabels[objData[0]] || formatTitle(objData[0])}
                    </label>
                    <div className={["field", "value"].join(" ")}>
                      {renderField(objData)}
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        )}
      </div>
    );
  }

  useEffect(() => {
    async function loadData() {
      try {
        let type = params.type;
        let discountData = null;

        // Fetch main view and group data
        const [viewResponse, groupResponse] = await Promise.all([
          fetch(`${chimeraserv.urlGet}/${type}/view/0`, {
            method: "POST",
            body: JSON.stringify({ id: params.id }),
            headers: headers,
          }),
          fetch(`${chimeraserv.urlGet}/group`, { headers: headers }),
        ]);

        if (!viewResponse.ok || !groupResponse.ok) {
          throw new Error(
            `API Error: view=${viewResponse.status}, group=${groupResponse.status}`
          );
        }

        const [view, group] = await Promise.all([
          viewResponse.json(),
          groupResponse.json(),
        ]);

        if (!view || !view[0]) {
          throw new Error("No data returned from view endpoint");
        }

        // If type is discount, fetch discount details by chaKey
        if (type === "discount" && view[0]?.chaKey) {
          const discountRes = await fetch(
            `${chimeraserv.urlGet}/discounts/byChaKey/${view[0].chaKey}`,
            { headers }
          );

          if (!discountRes.ok) {
            throw new Error(`Discount fetch failed: ${discountRes.status}`);
          }

          discountData = await discountRes.json();
        }

        const chainCurr = group[0].brands
          .filter((brandItem) => brandItem?.braKey === view[0]?.braKey)[0]
          ?.chains?.filter(
            (chainItem) => chainItem?.chaKey === view[0]?.chaKey
          )[0]?.currency;

        setData(view);
        setLoad(true);
        setCurrency({
          base: chainCurr?.toUpperCase() || group[0]?.baseCurr?.toUpperCase(),
          state: true,
        });

        // Store discountData in state if needed
        if (discountData) {
          setDiscount(discountData);
        }
      } catch (error) {
        console.error("Error loading data:", error);
        setData([]);
        setLoad(true);
        setDiscount([]);
      }
    }

    // Only load if we have necessary params
    if (params.id && params.type) {
      loadData();
    }
  }, [params.id, params.type, chimeraserv, user.data.usrKey]);

  // Defensive check for user
  if (!user || !user.data) {
    return <div>Please log in.</div>;
  }

  return (
    <div className={"viewContainer"}>
      <div className={["viewBody"]}>
        {views.includes(params.type)
          ? renderData()
          : components.setting[0].component
            ? React.createElement(components.setting[0].component)
            : null}
      </div>
    </div>
  );
}

export default View1;
